import * as React from 'react';

import type { TimeZoneProviderProps } from '../TimeZone';
import { TimeZoneProvider } from '../TimeZone';
import { useHrComponentsVersion } from './hrComponentsVersion';
import type { MountSettingsProviderProps } from './MountSettings';
import { MountSettingsProvider } from './MountSettings';

import 'src/Theme/presets/fonts/fonts.css';
import 'src/Theme/build/typography.css';
import 'src/Theme/build/colors.css';
import 'src/Theme/legacy.css';
import 'src/Theme/control.css';

type HrdsSettingsProps = React.PropsWithChildren<
    {} & MountSettingsProviderProps & TimeZoneProviderProps
>;

function HrdsSettings(props: HrdsSettingsProps) {
    useHrComponentsVersion({
        targetContainer: props.appContainer,
    });

    useHrComponentsVersion({
        targetContainer: props.popupContainer ?? null,
    });

    return (
        <MountSettingsProvider
            appContainer={props.appContainer}
            popupContainer={props.popupContainer}
        >
            <TimeZoneProvider timeZone={props.timeZone}>{props.children}</TimeZoneProvider>
        </MountSettingsProvider>
    );
}

export { HrdsSettings };
export type { HrdsSettingsProps };
